// src/components/admin/Topbar.jsx
export default function Topbar() {
    return (
      <header className="bg-white shadow px-6 py-4 flex justify-between items-center">
        <h1 className="text-xl font-semibold text-blue-700">Admin Panel</h1>
        <div className="text-sm text-gray-600">שלום רותם 👋</div>
      </header>
    );
  }
  